import Grid from "@mui/material/Grid2";

interface ImageColumnProps {
  images: string[];
  take: number;
  columns?: number;
  fromEnd?: boolean;
}

export default function ImageColumn({
  images,
  take,
  columns,
  fromEnd,
}: ImageColumnProps) {
  let imagesToDisplay = [];

  if (fromEnd) {
    images = images.reverse();
  }

  for (let i = 0; i < take; i++) {
    imagesToDisplay.push(images[i % images.length]);
  }

  return (
    <Grid
      container
      sx={{ overflow: "hidden", height: "100%" }}
    >
      {imagesToDisplay.map((image, index) => (
        <Grid
          key={index}
          sx={{ height: `${100*(columns??1) / imagesToDisplay.length}%` }}
          size={12 / (columns ?? 1)}
        >
          <img
            src={image}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              filter: window.innerWidth < 768 ? "":"brightness(30%)",
            }}
            crossOrigin="anonymous"
            alt={`gallery from establishment ${index}`}
          />
        </Grid>
      ))}
    </Grid>
  );
}
